export const runsKey = (dataset) => `pg_runs_${dataset}`
export const cacheKey = (dataset) => `pg_cache_${dataset}`

export function loadAllRuns() {
  try {
    const out = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith("pg_runs_")) {
        const dataset = k.replace("pg_runs_", "")
        const arr = JSON.parse(localStorage.getItem(k) || "[]")
        if (Array.isArray(arr)) {
          arr.forEach((r) => out.push({ ...r, _dataset: dataset }))
        }
      }
    }
    out.sort((a, b) => (b.ts || 0) - (a.ts || 0))
    return out
  } catch {
    return []
  }
}

export function saveRuns(dataset, runs) {
  try {
    localStorage.setItem(runsKey(dataset), JSON.stringify(runs))
  } catch {}
}

export const formatDateTime = (ts) => {
  try {
    return new Date(ts).toLocaleString()
  } catch {
    return String(ts)
  }
}

export const formatMetric = (v) =>
  typeof v === "number" ? (v % 1 === 0 ? v.toString() : v.toFixed(2)) : v
